type Props = {
  variant: "desktop" | "mobile"
}

export default function Meander({ variant }: Props) {
  switch (variant) {
    case "desktop":
      return (
        <svg
          className="absolute inset-0 h-full w-full"
          viewBox="0 0 900 620"
          fill="none"
          preserveAspectRatio="xMidYMid meet"
        >
          <path
            d="M 180,180
                           C 300,80 450,240 550,140
                           C 650,40 750,300 600,300
                           C 450,300 350,200 250,300
                           C 150,400 80,300 140,380
                           C 200,460 350,350 450,430
                           C 550,510 480,380 560,420"
            className="stroke-muted-foreground/40"
            strokeWidth="1.5"
            strokeDasharray="6 8"
            strokeLinecap="round"
          />
        </svg>
      )
    case "mobile":
      return (
        <svg
          className="absolute inset-0 h-full w-full"
          viewBox="0 0 400 1200"
          fill="none"
          preserveAspectRatio="none"
        >
          <path
            d="M 180,40
                           C 220,80 280,100 260,140
                           C 240,180 140,200 160,240
                           C 180,280 280,300 240,340
                           C 200,380 140,400 180,440
                           C 220,480 280,500 240,540
                           C 200,580 140,600 180,640
                           C 220,680 300,700 260,740
                           C 220,780 140,800 180,840
                           C 220,880 280,900 240,940
                           C 200,980 160,1000 200,1040
                           C 240,1080 280,1100 240,1140"
            className="stroke-muted-foreground/40"
            strokeWidth="1.5"
            strokeDasharray="6 8"
            strokeLinecap="round"
          />
        </svg>
      )
  }
}
